import { Vue, getElementData } from '@/main/appBluePrint'
import App from '@/apps/Schedule'

import store from '@/store/index'
import '@/store/modules/Facets'
import '@/store/modules/Results'
import '@/store/modules/Schedule'
import '@/store/modules/Selected'
import '@/store/modules/Facilities'

const element = document.getElementById('schedule')
const elementData = getElementData(element)

new Vue({
  store,
  render: (h) => h(App, { props: { elementData } })
}).$mount(element)
